<template>
  <div v-if="comType == 'UI'">
    <div
      class="navigation-bar-content"
      :style="{
        'background-color': backgroundColor,
        'background-image': `url(${backgroundImage})`,
        'background-size': 'cover',
      }"
    >
      <div :class="layoutMode">
        <div
          v-for="(item, index) in imgUrlList.slice(0, layoutModeNumMap[layoutMode])"
          :key="index"
          @click="activeIndex = index"
        >
          <img
            v-if="item.imgUrl || item.activeImgUrl"
            :src="activeIndex == index ? item.activeImgUrl || item.imgUrl : item.imgUrl"
          />
          <p
            :style="{
              color: activeIndex == index ? activeTextColor || textColor : textColor,
            }"
          >
            {{ item.jumpLink.remarktext }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="comType == 'config'">
    <el-form ref="form" label-width="100px" size="small">
      <div>
        <el-form-item label="布局样式">
          <div class="mode-content">
            <div
              class="list"
              :class="[
                {
                  active: item == layoutModeValue,
                },
              ]"
              v-for="item in Object.keys(layoutModeNumMap)"
            >
              <div
                class="box"
                :class="[
                  item,
                  {
                    active: item == layoutModeValue,
                  },
                ]"
                @click="layoutModeValue = item"
              >
                <div v-for="subitem in new Array(layoutModeNumMap[item]).fill('')"></div>
              </div>
            </div>
          </div>
        </el-form-item>
      </div>
      <div>
        <div class="collapse-content">
          <el-collapse :value="activeName" size="small">
            <el-collapse-item
              :name="index"
              :key="index"
              v-for="(item, index) in imgUrlListValue.slice(
                0,
                layoutModeNumMap[layoutModeValue]
              )"
            >
              <template slot="title">
                <el-form-item :label="`图片${index + 1}`">
                  <div class="collapse-title" @click.stop>
                    <jumpConfig
                      :jumpLink.sync="item.jumpLink"
                      jumpTypeLimit="onlyPage"
                    ></jumpConfig>
                  </div>
                </el-form-item>
              </template>
              <el-form-item label="导航名" v-if="item.jumpLink.remark">
                <el-input
                  type="text"
                  placeholder="请输入导航名"
                  size="small"
                  v-model="item.jumpLink.remarktext"
                  clearable
                  style="width: 280px"
                ></el-input>
              </el-form-item>
              <el-form-item label="默认图片">
                <customUpload :imageUrl.sync="item.imgUrl"></customUpload>
                <div class="tip">
                  {{ layoutModeTipMap[layoutModeValue][index] || "" }}
                </div>
              </el-form-item>
              <el-form-item label="激活图片">
                <customUpload :imageUrl.sync="item.activeImgUrl"></customUpload>
                <div class="tip">
                  {{ layoutModeTipMap[layoutModeValue][index] || "" }}
                </div>
              </el-form-item>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div>
        <el-form-item label="默认字体颜色">
          <el-color-picker
            v-model="textColorValue"
            :predefine="predefineColors"
            size="small"
          ></el-color-picker>
        </el-form-item>
        <el-form-item label="激活字体颜色">
          <el-color-picker
            v-model="activeTextColorValue"
            :predefine="predefineColors"
            size="small"
          ></el-color-picker>
        </el-form-item>
        <el-form-item label="背景颜色">
          <el-color-picker
            v-model="backgroundColorValue"
            :predefine="predefineColorsAlpha"
            size="small"
          ></el-color-picker>
        </el-form-item>
        <el-form-item label="背景图片">
          <customUpload :imageUrl.sync="backgroundImageValue"></customUpload>
          <div class="tip">建议图片 100px*750px</div>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import customUpload from "@/components/appltDecoration/customUpload";
import jumpConfig from "@/components/appltDecoration/jumpConfig";
import { comMixins } from "@/mixins/comMixins";
export default {
  mixins: [comMixins],
  name: "comNavigationBar",
  data() {
    return {
      layoutModeNumMap: {
        mode01: 2,
        mode02: 3,
        mode03: 4,
      },
      layoutModeTipMap: {
        mode01: ["建议图片 100px * 100px", "建议图片 100px * 100px"],
        mode02: [
          "建议图片 100px * 100px",
          "建议图片 100px * 100px",
          "建议图片 100px * 100px",
        ],
        mode03: [
          "建议图片 100px * 100px",
          "建议图片 100px * 100px",
          "建议图片 100px * 100px",
          "建议图片 100px * 100px",
        ],
      },
      activeName: [0, 1, 2, 3],
      activeIndex: 0,
    };
  },
  components: {
    customUpload,
    jumpConfig,
  },
  props: {
    comType: {
      type: String,
      default: "UI",
    },
    layoutMode: {
      type: String,
      default: "mode01",
    },
    imgUrlList: {
      type: Array,
      default: () => {
        return [
          {
            imgUrl: "",
            activeImgUrl: "",
            jumpLink: {
              type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
              remark: "",
              remarkText: "",
            },
          },
          {
            imgUrl: "",
            activeImgUrl: "",
            jumpLink: {
              type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
              remark: "",
              remarkText: "",
            },
          },
          {
            imgUrl: "",
            activeImgUrl: "",
            jumpLink: {
              type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
              remark: "",
              remarkText: "",
            },
          },
          {
            imgUrl: "",
            activeImgUrl: "",
            jumpLink: {
              type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
              remark: "",
              remarkText: "",
            },
          },
        ];
      },
    },
    textColor: {
      type: String,
      default: "rgb(51, 51, 51)",
    },
    activeTextColor: {
      type: String,
      default: "rgb(51, 51, 51)",
    },
    backgroundColor: {
      type: String,
      default: "rgb(255, 255, 255)",
    },
    backgroundImage: {
      type: String,
      default: "",
    },
  },
  computed: {
    layoutModeValue: {
      get() {
        return this.layoutMode;
      },
      set(val) {
        this.$emit(`update:layoutMode`, val);
      },
    },
    imgUrlListValue: {
      get() {
        return this.imgUrlList;
      },
      set(val) {
        this.$emit(`update:imgUrlList`, val);
      },
    },
    textColorValue: {
      get() {
        return this.textColor;
      },
      set(val) {
        this.$emit(`update:textColor`, val);
      },
    },
    activeTextColorValue: {
      get() {
        return this.activeTextColor;
      },
      set(val) {
        this.$emit(`update:activeTextColor`, val);
      },
    },
    backgroundColorValue: {
      get() {
        return this.backgroundColor;
      },
      set(val) {
        console.log("backgroundColor", val);
        this.$emit(`update:backgroundColor`, val);
        console.log("backgroundColor", this.backgroundColor);
      },
    },
    backgroundImageValue: {
      get() {
        return this.backgroundImage;
      },
      set(val) {
        console.log("backgroundImage", val);
        this.$emit(`update:backgroundImage`, val);
        console.log("backgroundImage", this.backgroundImage);
      },
    },
  },
};
</script>

<style scoped lang="less">
* {
  box-sizing: border-box;
}
.navigation-bar-content {
  height: 50px;
  background-color: #fff;
}
.navigation-bar-content > div {
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
}

.navigation-bar-content > div > div {
  height: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
}

.navigation-bar-content > div > div img {
  width: 20px;
  height: 20px;
  display: block;
}

.navigation-bar-content > div > div p {
  font-size: 14px;
  line-height: 21px;
  height: 21px;
}

.mode-content {
  display: flex;
  flex-wrap: wrap;
}

.mode-content .list {
  border: 1px solid #e4e7ed;
  height: 50px;
  min-width: 80px;
  max-width: 80px;
  flex: 1;
  margin-right: 10px;
  margin-bottom: 10px;
}

.mode-content .list.active {
  border: 1px solid #409eff;
}

.mode-content .list > div {
  padding: 5px;
  height: 100%;
  cursor: pointer;
}

.mode-content .list .box.active div {
  background-color: #409eff;
}

.mode-content .list .box div {
  background-color: #e4e7ed;
  margin-right: 5px;
}

.mode-content .list .box div:last-child {
  margin-right: 0;
}

.mode-content .list .mode01,
.mode-content .list .mode02,
.mode-content .list .mode03,
.mode-content .list .mode04 {
  display: flex;
  flex-wrap: nowrap;
}

.mode-content .list .mode01 div,
.mode-content .list .mode02 div,
.mode-content .list .mode03 div,
.mode-content .list .mode04 div {
  height: 100%;
  flex: 1;
}

.mode-content .list .mode05 div:first-child {
  min-height: 100%;
}

.mode-content .list .mode05 div:nth-child(2) {
  margin-bottom: 5px;
  margin-right: 0;
}

.mode-content .list .mode06 div:first-child {
  margin-bottom: 5px;
}

.mode-content .list .mode06 div:nth-child(3) {
  min-height: 100%;
}
</style>
